import React, {useEffect, useState} from "react";
import "./ConsoleOutput.css";
import Ansi from "ansi-to-react";
import Col from "react-bootstrap/Col";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from "react-bootstrap/Row";
import InputGroup from 'react-bootstrap/InputGroup';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faFilter, faX, faArrowsDownToLine, faFileArrowDown, faLink} from '@fortawesome/free-solid-svg-icons'
import {faTrashCan} from "@fortawesome/free-regular-svg-icons";




const cloudwatchLogsBaseUrl = "https://us-east-1.console.aws.amazon.com/cloudwatch/home?region=us-east-1#logsV2:log-groups/log-group/bond-palantir/log-events/"

function ConsoleOutput({bondId, messages, clearMessages}) {
    const [renderedMessages, setRenderedMessages] = useState(null);
    const [filterQuery, setFilterQuery] = useState("");
    const [highlightedIndices, setHighlightedIndices] = useState([]);
    const [isAutoScroll, setIsAutoScroll] = useState(true);

    useEffect(updateMessages, [messages, filterQuery, highlightedIndices]);
    useEffect(() => {
        if (isAutoScroll) {
            const consoleOutputDiv = document.getElementById("consoleOutput");
            consoleOutputDiv.scrollTop = consoleOutputDiv.scrollHeight;
        }
    }, [renderedMessages]);


    function updateMessages() {
        if (!messages) {
            setRenderedMessages(null);

            return;
        }
        const filteredMessages = messages.filter(message => message[1].toLowerCase().includes(filterQuery.toLowerCase()));
        setRenderedMessages(filteredMessages.map((message, index) => {
            const isHighlighted = highlightedIndices.includes(message);

            return <div
                className={`logLine  ${isHighlighted ? 'highlighted' : ''}`}
                key={index}
                onClick={() => toggleHighlight(message)}>
                <div className="logTimestamp">{message[0]}</div>
                <Ansi>{message[1]}</Ansi>
            </div>
        }));
    }

    function toggleHighlight(index) {
        setHighlightedIndices(prevIndices => prevIndices.includes(index) ? prevIndices.filter(i => i !== index) : [...prevIndices, index]);
    }

    function downloadMessages() {
        if (!messages) {
            return;
        }
        const element = document.createElement("a");

        const nonPrintableRegex = /[^\x20-\x7E]+/g;
        const ansiRegex = /(\x1b\[[0-9;]*m|\[[0-9;]*m)/g;

        const timestamp = new Date().toLocaleString('en-GB')
            .replace(/[/, ]/g, '-')
            .replace(/:/g, '_').replace(/--/g, '-')
            .replace(/...$/, '');

        const file = new Blob(messages.map((msg) => {
            const m = msg[1].replace(nonPrintableRegex, '').replace(ansiRegex, '').replace(/^\s+/, '');
            return `${msg[0]}\t${m}\n`;
        }), {type: 'text/plain'});

        element.href = URL.createObjectURL(file);
        element.download = "livelog_" + bondId + "_" + timestamp + ".txt";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    return (<Col id="consoleOutput" className="h-100">
        <Form.Group as={Row} className="consoleOutputForm sticky-top">
            <Col xs="8">
                <InputGroup className="mb-3">
                    <Button variant={isAutoScroll ? "primary" : "outline-primary"}
                            onClick={() => {
                                if (!isAutoScroll) {
                                    const consoleOutputDiv = document.getElementById("consoleOutput");
                                    consoleOutputDiv.scrollTop = consoleOutputDiv.scrollHeight;
                                }
                                setIsAutoScroll(!isAutoScroll);
                            }}><FontAwesomeIcon icon={faArrowsDownToLine}/>
                    </Button>
                    <InputGroup.Text id="basic-addon1">
                        <FontAwesomeIcon icon={faFilter}/>
                    </InputGroup.Text>
                    <Form.Control
                        aria-describedby="basic-addonx"
                        type="text"
                        placeholder=""
                        value={filterQuery}
                        autoComplete="filterLogs"
                        onChange={(e) => setFilterQuery(e.target.value)}
                    />
                    <Button variant="outline-secondary" className={"inputSideBtn"} id="button-addon2"
                            onClick={(e) => setFilterQuery("")}>
                        <FontAwesomeIcon icon={faX}/>
                    </Button>
                </InputGroup>
            </Col>
            <Col xs="4" className="text-start">
                <Button variant="outline-primary" className="downloadBtn">
                    <FontAwesomeIcon icon={faFileArrowDown} onClick={downloadMessages}/>
                </Button>
                <Button variant="outline-primary" className="downloadBtn"
                        onClick={() => window.open(cloudwatchLogsBaseUrl + bondId, '_blank', 'noopener,noreferrer')}
                >
                    <FontAwesomeIcon icon={faLink}/>
                </Button>
                <Button variant="outline-danger" onClick={clearMessages} className="float-end"><FontAwesomeIcon
                    icon={faTrashCan}/></Button>
            </Col>
        </Form.Group>
        {renderedMessages}
    </Col>);
}

export default ConsoleOutput;
